import { atom } from 'jotai'

export const tradeTabAtom = atom<number>(0)
export const tradeTabTrackBgAtom = atom<string>('#f47226')
